import React, { ReactElement } from "react";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import IconSelector from "components/shared/images/IconSelector";

import { getZoneDetails } from "redux/selectors/zoneSelector";

import ZoneRecords from "../ZoneRecords";

const ZoneRecordsManage = (): ReactElement => {
 const params = useParams<{ zone_id: string; section: string }>();

 const zoneDetails = useSelector(getZoneDetails);
 const filteredZone = zoneDetails?.find((element) => element.id === Number(params.zone_id));

 return (
  <Paper elevation={1} sx={{ borderRadius: "5px", p: 2 }}>
   <Stack spacing={2}>
    <Stack direction="row" alignItems="center" spacing={2}>
     <IconSelector icon="DnsIcon" props={{ fontSize: "medium", color: "kxOrange" }} />
     <Typography variant="unboundedTitle" ml={1} fontSize={16}>
      <FormattedMessage id="zone.manage.records" />
     </Typography>
    </Stack>
    <ZoneRecords
     zoneId={filteredZone?.zone_id || 0}
     ispId={filteredZone?.isp_id || 0}
     data={filteredZone?.records || []}
     domain={filteredZone?.zone || ""}
    />
   </Stack>
  </Paper>
 );
};

export default ZoneRecordsManage;
